import { render, staticRenderFns } from "./question-list.vue?vue&type=template&id=10436504&scoped=true&"
import script from "./question-list.vue?vue&type=script&lang=js&"
export * from "./question-list.vue?vue&type=script&lang=js&"
import style0 from "./question-list.vue?vue&type=style&index=0&id=10436504&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10436504",
  null
  
)

export default component.exports